import type { FC } from 'react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import type { FilterValues } from 'src/components/app/context/FilterContext';

import FilterChip from './FilterChip';

interface FilterChipGroupProps {
  filterName: string;
  values: FilterValues;
  showAll: boolean;
  maximumChips: number;
  onDeleteFilter: () => void;
  renderAnd: boolean;
  renderedFiltersCounter: number;

  formatLabel(name: string, values: FilterValues): string;
}

const FilterChipGroup: FC<FilterChipGroupProps> = ({
  filterName,
  values,
  showAll,
  maximumChips,
  renderAnd,
  renderedFiltersCounter,
  formatLabel,
  onDeleteFilter,
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {values.map((value, indexValue) => {
        if (renderedFiltersCounter + indexValue >= maximumChips && !showAll)
          return;
        const renderOr =
          values.length > 1 &&
          indexValue !== values.length - 1 &&
          !(
            renderedFiltersCounter + indexValue + 1 === maximumChips && !showAll
          );

        return (
          <FilterChip
            key={indexValue}
            filterName={filterName}
            renderOr={renderOr}
            value={value}
            onDeleteFilter={onDeleteFilter}
            formatLabel={formatLabel}
            pb={showAll ? 1 : 0}
          />
        );
      })}
      {renderAnd && (
        <Box sx={{ pb: showAll ? 1 : 0, px: 1 }}>
          <Typography variant="body1" sx={{ textTransform: 'uppercase' }}>
            {t('common:and')}
          </Typography>
        </Box>
      )}
    </Fragment>
  );
};

export default FilterChipGroup;
